module.exports = __webpack_public_path__ + "img/caja2.25be4e1c.png";